<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6Vl29s/tc-custom/9781452110011.jpg?1705766127402" alt="This image is the cover for the book Handmade Weddings"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Handmade Weddings
      </h1>
      <p class="bookDescription body article font2">
        <b>In this delightful book, the founders of Hello!Lucky join forces with a renowned wedding stylist to bring you over fifty gorgeous DIY projects. </b><br/>  <br/> Handcrafted details are at the heart of a beautiful wedding adding charm, meaning, and style.<br/>  <br/> Whether you favor a modern, classic look or a retro, homespun flavor, in <i>Handmade Weddings</i> you’ll find plenty of crafts and inspiration suited to your taste—from vintage key save-the-dates to delicate paper wreaths to silhouette bride and groom signs.<br/>  <br/> At the front of the book you’ll find guidance on choosing a look, sourcing materials, and working out timelines. Then, each of the fifty projects are fully explained with photos, how-to diagrams, and step-by-step directions.<br/>  <br/> Clever, creative, and budget-friendly, <i>Handmade Weddings</i> is the perfect handbook for the bride looking to style her day her way. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eunice Moyle, Sabrina Moyle, Shana Faust, Joseph De Leo
      </h2>
      
      <p class="authorDescription body article">Eunice Moyle, with Sabrina Moyle, co-founded Hello!Lucky in 2003 with a vintage Vandercook printing press. She is also co-author of <I>Handmade Hellos</I>. She lives in San Francisco.Shana Faust is a freelance stylist and the former Deputy Style Editor of <I>Martha Stewart Weddings</I>. She lives in New York City.<br/><br/>Joseph De Leo is a food and still life photographer based in New York City. His work has appeared in numerous books and magazines.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a5d26a4